<!-- 查询车辆信息接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure.vue"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "unionId": "oKRtNwDl4_NibsIsQd4Z0hQO-YGM",
          "startBillDate": "20190301000000",
          "endBillDate": "20230801000000"
        },
        responseCode: {
          "data": {
            "currCount": 1,
            "recordList": [
              {
                "billType": 0,
                "billName": "停车费",
                "billCode": "201903251453353",
                "billValue": 10.1,
                "billSuccessDate": "20190325145335"
              }
            ],
            "total": 1
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台,获取用户账单记录用于开票",
          t_url: this.commonUrls.test + "getUserBillRecordForInvoice",
          p_url: this.commonUrls.prod + "getUserBillRecordForInvoice",
          precondition: "无",
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'unionId', info2: '是', info3: 'String', info4: '微信用户unionId'},
              {info1: 'startBillDate', info2: '是', info3: 'String', info4: '订单下单开始时间，格式：yyyyMMddHHmmss'},
              {info1: 'endBillDate', info2: '是', info3: 'String', info4: '订单下单结束时间，格式：yyyyMMddHHmmss'}
            ]
          },],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              { info1: 'count', info2: '否', info3: 'Integer', info4: '当前取得的记录条数' },
              {info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '用户信息列表'},
            ]
          }, {
            titleName: 'recordList',
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkingCode', info2: '是', info3: 'String', info4: '账单流水编号'},
              {info1: 'billCode', info2: '是', info3: 'String', info4: '支付订单号'},
              {
                info1: 'billType',
                info2: '是',
                info3: 'Integer',
                info4: '账单类型：0:停车费，1：充值余额，2：购买月票，3:退款,4:租用车位,5:预约车位,6:余额退款,7:补交停车费,10:扫码支付'
              },
              {info1: 'billName', info2: '是', info3: 'String', info4: '账单类型名称'},
              {info1: 'shouldBillValue', info2: '是', info3: 'BigDecimal', info4: '应缴费用'},
              {info1: 'billValue', info2: '是', info3: 'BigDecimal', info4: '实付金额'},
              {info1: 'billOrderDate', info2: '是', info3: 'String', info4: '订单下单时间，格式：yyyyMMddHHmmss'},
              {info1: 'billSuccessDate', info2: '是', info3: 'String', info4: '支付成功时间，格式：yyyyMMddHHmmss'},
              {info1: 'payType', info2: '是', info3: 'Integer', info4: '支付方式:0:微信支付,1:支付宝,2:余额支付,3:余额支付,4:银联'},
              {info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码'},
              {info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编码'},
              {info1: 'couponList', info2: '否', info3: 'JSONArray', info4: '优惠列表'},
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getUserBillRecordForInvoice.vue